import Model from "@/models/Model"

export default class PchProvider extends Model {

    /**
     * 
     */
    static appends = [
        "branch_offices"
    ]

    /**
     * 
     */
    static includes = [
        "pch_provider_account",
    ]

    /**
     * 
     */
    get pch_provider_branch_offices_address () {
        return this.pch_provider_branch_offices.map( ({ address }) => address )
    }

    /**
     * 
     */
    resource() {
        return "pch_provider"
    }
}